import { h } from "preact";
import { useState } from "preact/hooks";
import {
  rgbToRgba,
  calculateForeground
} from "../internal_utilities/utilities";

function ContentCard({
  title,
  color,
  ctaText,
  giftCode,
  copyText,
  explainertext,
  onClose
}) {
  const [isClicked, setIsClicked] = useState(false);

  return (
    <div
      style={{
        maxWidth: `690px`
      }}
      className="corner-modal-card flex flex-col md:flex-row bg-white rounded-lg m-3 sm:w-full md:w-2/3 lg:w-1/2 lg:h-96 shadow-lg overflow-hidden"
    >
      <div
        ref={node => {
          if (node)
            node.style.setProperty(
              "background",
              `linear-gradient(180deg, ${rgbToRgba(color, 0.2)} 0%, ${rgbToRgba(
                color,
                0
              )}  100%)`
            );
        }}
        className="corner-gift-share-page-banner pt-7 pb-5 md:py-8 px-8 text-center w-full md:w-1/2 shrink-0 flex flex-col items-center md:items-start justify-center "
      >
        <h1
          className={`text-2xl font-bold text-black text-left leading-8 text-center md:text-left`}
        >
          {title}
        </h1>

        <div className="flex justify-center md:justify-start mt-5 ">
          <div className="bg-white shadow-md rounded-lg flex justify-between items-stretch overflow-hidden border border-gray-100">
            <h3 className="text-xl font-bold m-0 py-4 px-2">{giftCode}</h3>
            <a
              onClick={() => {
                navigator.clipboard.writeText(giftCode);
                setIsClicked(true);
                setTimeout(function() {
                  setIsClicked(false);
                }, 3000);
              }}
              className="flex items-center border-l border-dotted text-sm ml-3 py-4 px-2 bg-gray-100 cursor-pointer"
            >
              {isClicked ? <span className="mx-3">👍</span> : copyText}
            </a>
          </div>
        </div>
      </div>
      <div className="mt-1 md:mt-5 p-5 flex flex-col justify-center items-center md:items-start">
        {explainertext && (
          <p className="text-center md:text-left">{explainertext}</p>
        )}
        <a
          href="#"
          onClick={onClose}
          ref={node => {
            if (node) {
              node.style.setProperty("background", color, "important");
              node.style.setProperty("color", calculateForeground(color));
            }
          }}
          className="mt-5 px-8 py-4 rounded-lg max-w-fit opacity-100 hover:opacity-90 transition-opacity"
        >
          {ctaText}
        </a>
        <div />
      </div>
    </div>
  );
}

export default ContentCard;
